import { z } from 'zod/v4';
import { CaseStatus } from '../cases/index.js';
export var BulkActionType;
(function (BulkActionType) {
    BulkActionType["MoveCaseStatus"] = "MOVE_CASE_STATUS";
    BulkActionType["PauseCases"] = "PAUSE_CASES";
    BulkActionType["ContinueCases"] = "CONTINUE_CASES";
    BulkActionType["RunProcedure"] = "RUN_PROCEDURE";
    BulkActionType["ChangeBillingModel"] = "CHANGE_BILLING_MODEL";
    BulkActionType["ChangeBillingAppendixSetup"] = "CHANGE_BILLING_APPENDIX_SETUP";
    BulkActionType["ChangeWorkflow"] = "CHANGE_WORKFLOW";
    BulkActionType["MoveCaseToWorkflowTask"] = "MOVE_WORKFLOW_TASK";
    BulkActionType["RollbackOneTask"] = "ROLLBACK_ONE_TASK";
    BulkActionType["RollbackAllTasks"] = "ROLLBACK_ALL_TASKS";
    BulkActionType["RunBillingModel"] = "RUN_BILLING_MODEL";
    BulkActionType["ResubscribeCosmo"] = "RESUBSCRIBE_COSMO";
    BulkActionType["ChangeCaseGroup"] = "CHANGE_CASE_GROUP";
    BulkActionType["ResyncCosmo"] = "RESYNC_COSMO";
    BulkActionType["DeleteRKIRegistrationsOnEndedCases"] = "DELETE_RKI_REGISTRATIONS_ON_ENDED_CASES";
    BulkActionType["MoveRKIRegistrationsToMergeCases"] = "MOVE_RKI_REGISTRATIONS_TO_MERGE_CASES";
})(BulkActionType || (BulkActionType = {}));
export const BulkActionSchema = z.union([
    z.object({
        type: z.literal(BulkActionType.MoveCaseStatus),
        details: z.object({
            status: z.literal(CaseStatus.ENDED),
            endReasonId: z.string(),
        }),
    }),
    z.object({
        type: z.literal(BulkActionType.MoveCaseStatus),
        details: z.object({
            status: z.literal(CaseStatus.VERIFIED),
            endReasonId: z.null(),
        }),
    }),
    z.object({
        type: z.literal(BulkActionType.PauseCases),
        details: z.object({
            updateTypeId: z.string(),
            update: z.string().optional(),
        }),
    }),
    z.object({
        type: z.literal(BulkActionType.ContinueCases),
        details: z.object({ updateTypeId: z.string() }),
    }),
    z.object({
        type: z.literal(BulkActionType.RunProcedure),
        details: z.object({ procedureId: z.string() }),
    }),
    z.object({
        type: z.literal(BulkActionType.ChangeBillingModel),
        details: z.object({ billingModelId: z.string() }),
    }),
    z.object({
        type: z.literal(BulkActionType.ChangeBillingAppendixSetup),
        details: z.object({ billingAppendixSetupId: z.string() }),
    }),
    z.object({
        type: z.literal(BulkActionType.ChangeWorkflow),
        details: z.object({ workflowId: z.string() }),
    }),
    z.object({
        type: z.literal(BulkActionType.MoveCaseToWorkflowTask),
        details: z.object({
            workflowId: z.string(),
            targetTaskId: z.string(),
        }),
    }),
    z.object({
        type: z.literal(BulkActionType.RollbackAllTasks),
        details: z.object({}),
    }),
    z.object({
        type: z.literal(BulkActionType.RollbackOneTask),
        details: z.object({}),
    }),
    z.object({
        type: z.literal(BulkActionType.RunBillingModel),
        details: z.object({}),
    }),
    z.object({
        type: z.literal(BulkActionType.ResubscribeCosmo),
        details: z.object({}),
    }),
    z.object({
        type: z.literal(BulkActionType.DeleteRKIRegistrationsOnEndedCases),
        details: z.object({}),
    }),
    z.object({
        type: z.literal(BulkActionType.MoveRKIRegistrationsToMergeCases),
        details: z.object({}),
    }),
    z.object({
        type: z.literal(BulkActionType.ResyncCosmo),
        details: z.object({}),
    }),
    z.object({
        type: z.literal(BulkActionType.ChangeCaseGroup),
        details: z.object({ caseGroupId: z.string() }),
    }),
]);
//# sourceMappingURL=bulk-actions.js.map